"use strict";
/**
 * 多语言配置文件
 * 支持语言：简体中文 (0)、英文 (2)
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.langTextMap = exports.LanguageId = void 0;
exports.getRatingLevelText = getRatingLevelText;
exports.getAnalystRatingText = getAnalystRatingText;
const enum_1 = require("./enum");
// 语言 ID 枚举
var LanguageId;
(function (LanguageId) {
    /** 简体中文 */
    LanguageId[LanguageId["SC"] = 0] = "SC";
    /** 英文 */
    LanguageId[LanguageId["EN"] = 2] = "EN";
})(LanguageId || (exports.LanguageId = LanguageId = {}));
// 多语言文案映射表
exports.langTextMap = {
    [LanguageId.SC]: {
        // ========== 通用 ==========
        more: '更多',
        new: '今日新增',
        latest: '最新',
        criteria: '选股条件',
        update: '更新',
        explanation: '信号说明',
        // ========== 模块标题 ==========
        selected_stocks: '入选股票',
        analyst_updates: '分析师动态',
        // ========== 触发信号 ==========
        trigger_signal: '触发信号',
        // ========== 评级相关 ==========
        latest_rating_changes: '最新评级变动',
        rating_buy: '买入',
        rating_hold: '持有',
        rating_sell: '卖出',
        rating_underperform: '不及预期',
        rating_strong_buy: '强烈买入',
        rating: '评级',
        target: '目标价',
        target_price: '目标价',
        consensus_rating: '综合评级',
        // ========== 筹码分布 ==========
        market_position_overview: '筹码分布',
        profit_ratio: '获利比例',
        support: '支撑位',
        avg_cost: '平均成本',
        resistance: '压力位',
        // ========== 股票行情 ==========
        week_52_high: '52周最高',
        // ========== 分析师统计 ==========
        analyst_rating: '分析师等级',
        success_rate: '胜率',
        total_success_rate: '总胜率',
        total_average_return: '总平均回报',
        average_return: '平均回报',
        // ========== AI 分析 ==========
        ai_analysis_title: '的AI分析',
        updated: '更新时间:',
        ask_ai_more: '向AI提问',
        view_stock_details: '查看股票详情',
        ai_analysis: 'AI分析',
        // ========== 评级触发信号（写死的） ==========
        rating_trigger_signal: '1日内发生机构评级调整的个股',
        analyst_trigger_signal: '总胜率排名TOP10分析师评级调整',
        noData: '当前网络异常，请刷新后重试'
    },
    [LanguageId.EN]: {
        // ========== 通用 ==========
        more: 'More',
        new: 'NEW',
        latest: 'Latest',
        criteria: 'Criteria',
        update: 'Update on',
        explanation: 'Explanation',
        // ========== 模块标题 ==========
        selected_stocks: 'Selected Stocks',
        analyst_updates: 'Analyst Updates',
        // ========== 触发信号 ==========
        trigger_signal: 'Trigger Signal',
        // ========== 评级相关 ==========
        latest_rating_changes: 'Latest Rating Changes',
        rating_buy: 'Buy',
        rating_hold: 'Hold',
        rating_sell: 'Sell',
        rating_underperform: 'Underperform',
        rating_strong_buy: 'Strong Buy',
        rating: 'Rating',
        target: 'Target',
        target_price: 'Target Price',
        consensus_rating: 'Consensus Rating',
        // ========== 筹码分布 ==========
        market_position_overview: 'Market Position Overview',
        profit_ratio: 'Profit Ratio',
        support: 'Support',
        avg_cost: 'Avg Cost',
        resistance: 'Resistance',
        // ========== 股票行情 ==========
        week_52_high: '52wk High',
        // ========== 分析师统计 ==========
        analyst_rating: 'Analyst Rating',
        success_rate: 'Success Rate',
        total_success_rate: 'Success Rate',
        total_average_return: 'Total Average Return',
        average_return: 'Average Return',
        // ========== AI 分析 ==========
        ai_analysis_title: "'s AI Analysis",
        updated: 'Updated:',
        ask_ai_more: 'Ask AI More',
        view_stock_details: 'View Stock Details',
        ai_analysis: 'AI',
        // ========== 评级触发信号（写死的） ==========
        rating_trigger_signal: 'Rating changes within 1 day',
        analyst_trigger_signal: 'Top 10 Analysts Rating Updates',
        noData: 'Network exception, please refresh and try again'
    }
};
/**
 * 获取评级等级的多语言文案
 * @param level 评级等级 (1: Sell, 2: Hold, 3: Buy)
 * @param languageId 语言 ID
 */
function getRatingLevelText(level, languageId) {
    const langMap = exports.langTextMap[languageId] || exports.langTextMap[LanguageId.EN];
    switch (level) {
        case 1:
            return langMap.rating_sell;
        case 2:
            return langMap.rating_hold;
        case 3:
            return langMap.rating_buy;
        default:
            return langMap.rating_hold;
    }
}
function getAnalystRatingText(rating, languageId) {
    const langMap = exports.langTextMap[languageId] || exports.langTextMap[LanguageId.EN];
    switch (rating) {
        case enum_1.AnalystRating.RATING_SELL:
            return langMap.rating_sell;
        case enum_1.AnalystRating.RATING_UNDERPERFORM:
            return langMap.rating_underperform;
        case enum_1.AnalystRating.RATING_HOLD:
            return langMap.rating_hold;
        case enum_1.AnalystRating.RATING_BUY:
            return langMap.rating_buy;
        case enum_1.AnalystRating.RATING_STRONG_BUY:
            return langMap.rating_strong_buy;
        default:
            return langMap.rating_hold;
    }
}
//# sourceMappingURL=data:application/json;base64,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